import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ActiveUsersData } from 'model/mobile-app-dashboard';

@customElement('active-users-box')
export class ActiveUserssBoxCustomElement {
  @bindable
  data: ActiveUsersData;

  @computedFrom('data.headerActiveUsers')
  get headlineTitle() {
    return `Active Users in ${this.data?.headerActiveUsers.dateRangeName.toLowerCase()}`;
  }
}
